import { type FC } from 'react';
import {
  HardDrives
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconHardDrivesProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconHardDrives: FC<UiIconHardDrivesProps> = (props) => {
  return (
    <UiIcon
      IconComponent={HardDrives}
      {...props}
    />
  );
};
